(() => {
  const BFMVideosGridSwiper = () => {
    const selectors = {
      component: "bfm-videos-grid",
      swiperPagination: ".swiper-pagination",
      filters: ".bfm-videos-grid__filters-destination",
      categories: ".bfm-videos-grid__category",
      gridContainer: ".bfm-videos-grid__container",
      totalVideos: ".js-total-videos",
      slides: ".bfm-videos-grid__videos-item",
      slidesWrapper: ".bfm-videos-grid__videos-grid",
      bfmPagination: ".js-swiper-pagination-bfm",
    };
    const isSwiper = (element) => window.innerWidth < 1023 && !element.querySelector(".mod--category-style");
    const swiperInstances = new WeakMap();

    const firstResults = [];

    const saveFirstResults = (component) => {
      const allCategories = Array.from(component.querySelectorAll(selectors.categories));
      const totalVideos = component.querySelector(selectors.totalVideos)?.textContent || 0;
      const categories = [];

      allCategories.forEach((category) => {
        const element = category;
        const videoElements = Array.from(category.querySelectorAll(selectors.slides));
        const videos = videoElements.map((el) => ({
          selector: el.getAttribute("data-selector"),
          videoImage: el.querySelector("[data-asset]")?.getAttribute("data-asset") || null,
          title: el.getAttribute("data-video-title"),
        }));
        categories.push({ element, videos });
      });

      firstResults.push({ component, categories, totalVideos });
    };

    const toggleSwiperClasses = (component) => {
      const swiperContainers = component.querySelectorAll(".bfm-videos-grid__videos");
      swiperContainers.forEach((swiperContainer) => {
        const wrapper = swiperContainer?.querySelector(selectors.slidesWrapper);
        const pagination = swiperContainer?.querySelector(selectors.swiperPagination);
        const slides = swiperContainer?.querySelectorAll(".bfm-videos-grid__videos-item");
        if (!swiperContainer || !wrapper || !slides || !pagination) {
          return;
        }
        const currentSwiper = swiperInstances.get(swiperContainer);

        if (isSwiper(component)) {
          if (!currentSwiper) {
            swiperContainer.classList.add("swiper");
            wrapper.classList.add("swiper-wrapper");
            pagination.classList.remove("hidden");
            slides.forEach((slide) => slide.classList.add("swiper-slide"));

            const swiperInstance = new window.Swiper(swiperContainer, {
              grabCursor: true,
              centeredSlides: true,
              loop: true,
              slidesPerView: 1.3,
              spaceBetween: 8,
              pagination: {
                el: swiperContainer.querySelector(selectors.swiperPagination),
                clickable: true,
              },
            });
            swiperInstances.set(swiperContainer, swiperInstance);
          }
        } else {
          if (currentSwiper) {
            currentSwiper.destroy(true, true);
            swiperInstances.delete(swiperContainer);
          }
          swiperContainer.classList.remove("swiper");
          wrapper.classList.remove("swiper-wrapper");
          pagination.classList.add("hidden");
          slides.forEach((slide) => slide.classList.remove("swiper-slide"));
        }
      });
    };

    const toggleAllSwiperClasses = () => {
      const components = Array.from(document.getElementsByClassName(selectors.component));
      components.forEach((component) => {
        toggleSwiperClasses(component);
      });
    };

    const destroyAllSwipers = (component) => {
      const swiperContainers = component.querySelectorAll(".bfm-videos-grid__videos.swiper");
      swiperContainers.forEach((container) => {
        const instance = swiperInstances.get(container);
        if (instance) {
          instance.destroy(true, true);
          swiperInstances.delete(container);
        }
        container.classList.remove("swiper");
        const wrapper = container.querySelector(".bfm-videos-grid__videos-grid");
        if (wrapper) {
          wrapper.classList.remove("swiper-wrapper");
        }
        const pagination = container.querySelector(selectors.bfmPagination);
        pagination.classList.add("hidden");
        const slides = container.querySelectorAll(".bfm-videos-grid__videos-item");
        slides.forEach((slide) => slide.classList.remove("swiper-slide"));
      });
    };

    const loadTemplateImage = async (component, selector, thumbnail, title) => {
      const container = component.querySelector(".bfm-videos-grid__container");
      const videoSelector = container.getAttribute("data-template-url").replace(".html", `.${selector}.html`);
      const resourcePath = container.getAttribute("data-resource-path");
      const showVideosTitle = container.dataset.showVideosTitle;
      let fullPath;
      if (showVideosTitle && title) {
        fullPath = `${resourcePath}.card-image.html${thumbnail}?videoSelector=${videoSelector}&videoTitle=${title}`;
      } else {
        fullPath = `${resourcePath}.card-image.html${thumbnail}?videoSelector=${videoSelector}`;
      }

      const res = await fetch(fullPath);
      return await res.text();
    };

    const loadData = async (videos, component, sectionCategory) => {
      destroyAllSwipers(component);

      const wrapper = sectionCategory.querySelector(selectors.slidesWrapper);
      wrapper.innerHTML = "";

      const templates = await Promise.all(videos.map((video) => loadTemplateImage(component, video.selector, video.videoImage, video.title)));

      wrapper.innerHTML = templates.join("");
      sectionCategory.style.display = videos.length === 0 ? "none" : "block";

      if (isSwiper(component)) {
        const swiperContainer = wrapper.closest(".bfm-videos-grid__videos");
        const slides = wrapper.querySelectorAll(selectors.slides);
        const pagination = swiperContainer.querySelector(selectors.swiperPagination);

        swiperContainer.classList.add("swiper");
        wrapper.classList.add("swiper-wrapper");
        slides.forEach((slide) => {
          slide.classList.add("swiper-slide");
        });
        pagination?.classList.remove("hidden");

        const swiperInstance = new window.Swiper(swiperContainer, {
          grabCursor: true,
          centeredSlides: true,
          loop: true,
          slidesPerView: 1.3,
          spaceBetween: 8,
          pagination: {
            el: pagination,
            clickable: true,
          },
        });
        swiperInstances.set(swiperContainer, swiperInstance);
      }
    };

    const loadFirstResults = (component) => {
      const currentObj = firstResults.find((firstRes) => firstRes.component == component);
      currentObj.categories.forEach((category) => {
        loadData(category.videos, component, category.element);
      });
    };

    const filterCategories = (response, component) => {
      const categoriesData = JSON.parse(response.response);
      const totalVideos = component.querySelector(selectors.totalVideos);
      totalVideos.innerHTML = categoriesData.totalVideos;

      categoriesData.categories.forEach((cat) => {
        loadData(cat.videos, component, component.querySelector(`[id="${cat.id}"]`));
      });
    };

    const removeFilteredContent = (component) => {
      const totalVideos = component.querySelector(selectors.totalVideos);
      const initialTotalVideos = firstResults.find((res) => res.component == component).totalVideos;
      totalVideos.innerHTML = initialTotalVideos;
      loadFirstResults(component);
    };

    const initFilters = (component) => {
      const componentPath = component.querySelector(selectors.gridContainer).getAttribute("data-resource-path");
      const filters = component.querySelectorAll(selectors.filters);
      filters.forEach((filter) => {
        filter.addEventListener("click", () => {
          const destinationPath = filter.getAttribute("data-path");
          const url = `${componentPath}.bcldata.json?dest=${destinationPath}`;

          if (filter.classList.contains("mod--selected")) {
            filter.classList.remove("mod--selected");
            removeFilteredContent(component);
          } else {
            filters.forEach((f) => {
              f.classList.remove("mod--selected");
            });
            filter.classList.add("mod--selected");
            bcl.ajax.getRequest(null, url, filterCategories, component);
          }
        });
      });
    };

    const components = Array.from(document.getElementsByClassName(selectors.component));
    components.forEach((component) => {
      initFilters(component);
      saveFirstResults(component);
    });

    document.addEventListener("DOMContentLoaded", toggleAllSwiperClasses);
    window.addEventListener("resize", toggleAllSwiperClasses);
  };

  BFMVideosGridSwiper();
})();
